import React from 'react';
import classNames from 'classnames';
import { FieldProps } from 'formik';

import ErrorMessage from '../ErrorMessage/ErrorMessage';
import { ExtraStyleType, FieldCustom } from '../FieldCustom/FieldCustom';

import styles from './RadioFieldCustom.module.scss';

export default function RadioFieldCustom({
  disabled,
  extraStyle,
  label,
  name,
  options,
  required,
  isErrorVisible,
  autoComplete,
}: {
  disabled?: boolean;
  extraStyle?: ExtraStyleType;
  label?: string;
  name: string;
  options: OptionType[];
  required?: boolean;
  isErrorVisible?: boolean;
  autoComplete?: string;
}): JSX.Element {
  return (
    <>
      <FieldCustom
        component={CustomizedRadioGroupField}
        disabled={disabled}
        {...(extraStyle && { extraStyle: extraStyle })}
        label={label}
        name={name}
        required={required}
        type="radio"
        isErrorVisible={isErrorVisible}
        autoComplete={autoComplete}
        options={options}
      />
      {isErrorVisible !== undefined && !isErrorVisible && (
        <ErrorMessage
          name={name}
          additionalClass={classNames(
            styles.errorLabel,
            extraStyle?.labelErrorMessage
          )}
        />
      )}
    </>
  );
}

const CustomizedRadioGroupField = ({
  form,
  field,
  options,
  autoComplete,
}: FieldProps & {
  options?: OptionType[];
  autoComplete?: HTMLInputElement['autocomplete'];
}) => {
  const { name } = field;
  const fieldValue = form.values[name];

  return (
    <div className={styles.radioGroup} role="group">
      {options?.map(option => {
        const { label, value } = option;
        const inputId = `${name}_${value}`;

        return (
          <div key={value.toString()}>
            <input
              {...field}
              type="radio"
              id={inputId}
              value={value.toString()}
              checked={value == fieldValue}
              autoComplete={autoComplete}
            />
            <label htmlFor={inputId}>{label}</label>
          </div>
        );
      })}
    </div>
  );
};

export type OptionType = {
  disabled?: boolean;
  label: string;
  selected?: boolean;
  value: string | number | boolean;
};
